import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Card from 'components/global/Card';
import Icon from 'components/global/Icon';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalTitle } from 'components/global/styled/Modal.styled';

import { getOTOPackageList } from 'pages/OTOModules/OTOPackageListSlice';
import SubscriptionAccountModal from 'pages/Settings/Payment/SubscriptionAccount/SubscriptionAccountModal';

import PATHS from 'utils/paths';

import { faArrowUp, faPhone } from '@fortawesome/pro-solid-svg-icons';

import {
	ButtonContainer,
	Container,
	LeftContainer,
	Logo,
	LogoPlaceholder,
	LogoWrapper,
	RightContainer
} from './UpgradeEnterprise.styled';

/**
 * @author @muhammedburakak
 */

const UpgradeEnterprise = NiceModal.create(() => {
	// Hooks and states declaration
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const modal = useModal();

	const items = useMemo(
		() => [
			{
				title: 'WMS',
				key: 'wms',
				subtitle: 'warehouseManagementSystem'
			},
			{
				title: 'DMS',
				key: 'dms',
				subtitle: 'documentManagementSystem'
			},
			{
				title: 'ERP',
				key: 'erp',
				subtitle: 'enterpriseResourcePlanning'
			}
		],
		[]
	);

	const currentPlanName = useSelector((state) => state.user.planName);
	const { otoPackageList: packages } = useSelector((state) => state?.otoPackageList);
	const integrations = useSelector((state) => state.integrationsStores);

	const [currentPackage, setCurrentPackage] = useState({});

	useEffect(() => {
		dispatch(getOTOPackageList());
	}, []);

	useEffect(() => {
		setCurrentPackage(packages.find((item) => item.planName === currentPlanName));
	}, [packages, currentPlanName]);

	return (
		<Modal fullwidth maxWidth="large" className="modal-upgradeOmni">
			<Container>
				<LeftContainer>
					<ModalTitle>
						<Typography variant="p1" fontWeight="700" noWrap>
							{currentPlanName !== 'EnterprisePackage'
								? 'smsIntegrationUpgradeEnterpriseHeader'
								: 'smsIntegrationUpgradeForEnterpriseHeader'}
						</Typography>
					</ModalTitle>
					<div>
						<div className="row row-cols-1 row-cols-lg-2">
							{items.map((item, index) => (
								<div key={index}>
									<Card>
										<div className="row row-cols-1 row-cols-lg-1">
											<Typography variant="p2" fontWeight="500" className="mb-1">
												{item.title}
											</Typography>
											<Typography fontWeight="500">{item.subtitle}</Typography>{' '}
											<div style={{ display: 'flex', flexWrap: 'wrap' }}>
												<LogoWrapper>
													{integrations
														?.filter((el) => el.type === item.key)
														?.map((item, index) => {
															if (index < 5) {
																return (
																	<Logo
																		width={'4.5rem'}
																		height={'4.5rem'}
																		key={index}
																		url={item?.logo}
																	/>
																);
															}
														})}
												</LogoWrapper>
												{integrations?.filter((el) => el.type === item.key)?.length > 5 && (
													<LogoPlaceholder>
														<Typography style={{ color: 'var(--white)' }}>
															+
															{integrations?.filter((el) => el.type === item.key)
																?.length - 5}
														</Typography>
													</LogoPlaceholder>
												)}
											</div>
										</div>
									</Card>
								</div>
							))}
						</div>
					</div>
				</LeftContainer>
				<RightContainer>
					<div className="mb-4">
						<Icon
							size="medium"
							icon={currentPlanName !== 'EnterprisePackage' ? faArrowUp : faPhone}
							style={{
								background: 'var(--blue)',
								borderRadius: '50%',
								color: 'var(--white)',
								padding: '0.4rem 0.2rem'
							}}
						/>
					</div>

					<Typography variant="p2" fontWeight="500" className="mb-4" noWrap>
						{currentPlanName !== 'EnterprisePackage'
							? 'upgradeUnlockThisFeature'
							: 'smsIntegrationUpgradeForEnterpriseHeader'}
					</Typography>
					<Typography className="mb-4" noWrap>
						{currentPlanName !== 'EnterprisePackage'
							? 'smsIntegrationUpgradeEnterpriseDescription'
							: 'smsIntegrationUpgradeForEnterpriseDescription'}
					</Typography>

					<ButtonContainer>
						{currentPlanName !== 'EnterprisePackage' && (
							<Button
								variant="outline"
								className="mx-3"
								label="showPlans"
								onClick={() => {
									navigate(PATHS.OTO_MODULES);
									modal.remove();
								}}
							/>
						)}

						{currentPackage?.planName !== 'EnterprisePackage' && (
							<Button
								label="contactSales"
								onClick={() => {
									modal.remove();
									NiceModal.show(SubscriptionAccountModal, {
										currentPackage,
										selectedPackage: packages.find((item) => item.planName === 'EnterprisePackage'),
										selectedPlanType: 'MONTHLY'
									});
								}}
							/>
						)}
					</ButtonContainer>
				</RightContainer>
			</Container>
		</Modal>
	);
});

export default UpgradeEnterprise;
